import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import JsonViewer from 'vue-json-viewer'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.min.css'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import VueClipboard from 'vue-clipboard2'
import VueI18n from 'vue-i18n'

// import SSJJ2UI from 'ssjj2-ui'
// import 'ssjj2-ui/lib/theme-chalk/index.css'
import './assets/style/normalize.css'
import './assets/style/common.scss'
import components from '@/components'

Vue.use(VueAwesomeSwiper /* { 全局组件的默认选项 } */)
Vue.use(ElementUI)
// Vue.use(SSJJ2UI)
Vue.use(JsonViewer)
Vue.use(VueClipboard)
Vue.use(VueI18n)
Vue.config.productionTip = false

components.forEach(item => {
  Vue.component(item.name, item)
})

const i18n = new VueI18n({
  locale: 'en-us',
  fallbackLocale: 'en-us',
  messages: {
    'zh-cn': require('./lang/zh-cn.json'),
    'en-us': require('./lang/en-us.json'),
    'vi-vn': require('./lang/vi-vn.json'),
    ru: require('./lang/ru.json')
  }
})

// 配置每个路由页面的标题,优先兼容游戏大厅语言传参，其次兼容路由传参
router.beforeEach((to, from, next) => {
  const local = to.query.lang
  const locales = ['en-us', 'vi-vn', 'zh-cn', 'ru']
  if (local && locales.includes(local)) {
    i18n.locale = local
    window.localLang = local
  } else {
    window.localLang = i18n.locale
  }
  if (to.meta.title) {
    document.title = i18n.t(to.meta.title)
  }
  if (to.path) { // 加入百度统计
    // console.log(to)
    if (window._hmt) {
      window._hmt.push(['_trackPageview', to.fullPath])
    }
  }
  next()
})

/* router.beforeEach((to, from, next) => {
  // if (to.meta.title) {
  //   document.title = to.meta.title;
  // }
  if (to.path) { // 加入百度统计
    // console.log(to)
    if (window._hmt) {
      window._hmt.push(['_trackPageview', to.fullPath])
    }
  }
  next()
}) */

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
